import { Button, Col, Collapse, Divider, Empty, Modal, Spin, message, Tag, Card, Row, Image } from 'antd'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import dayjs from 'dayjs';
import { FilePdfOutlined } from '@ant-design/icons';
import { baseUrlAREA, CHECK_CONTNO, HEADERS_BASIC } from '../../../API/apiUrlsNew';

function ImageSection({ images }) {
    if (!images || images.length === 0) return null;

    return (
        <Col span={24} style={{ marginTop: 8 }}>
            <b>รูปภาพ :</b>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6 }}>
                {images.map((e, i) => {
                    const isPdf = e.fileName?.toLowerCase().endsWith('.pdf');
                    return isPdf ? (
                        <div
                            key={e.imageId || i}
                            onClick={() => window.open(e.imageUrl, '_blank')}
                            style={{ cursor: 'pointer', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee', borderRadius: 8 }}
                        >
                            <FilePdfOutlined style={{ fontSize: 36, color: '#ff4d4f' }} />
                        </div>
                    ) : (
                        <Image
                            key={e.imageId || i}
                            width={80}
                            height={80}
                            src={e.imageUrl}
                            style={{ borderRadius: 8, objectFit: 'cover' }}
                        />
                    );
                })}
            </div>
        </Col>
    );
}

function CheckCONTNO({ open, close, data }) {
    const [loading, setLoading] = useState(false);
    const [workDemandGuaranter, setWorkDemandGuaranter] = useState([]);
    const [workCancelContract, setWorkCancelContract] = useState([]);
    const [letterCarRepurchase, setLetterCarRepurchase] = useState([]);
    const [letterAuctionResult, setLetterAuctionResult] = useState([]);

    useEffect(() => {
        if (data) {
            loadData(data)
        }
    }, [data])

    const loadData = async (value) => {
        setLoading(true);
        await axios.get(baseUrlAREA + `${CHECK_CONTNO}/${value}`, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    console.log("res.data", res.data)
                    setLetterCarRepurchase(res.data.letterCarRepurchase || [])
                    setWorkCancelContract(res.data.workCancelContract || [])
                    setWorkDemandGuaranter(res.data.workDemandGuaranter || [])
                    setLetterAuctionResult(res.data.letterAuctionResult || [])
                    setLoading(false);
                    message.success("โหลดข้อมูลสำเร็จ");
                }
            })
            .catch((err) => {
                setLoading(false);
                message.error("โหลดข้อมูลไม่สำเร็จ !! ");
                console.log(err);
            });
    }

    // console.log("data", data)

    const handleClose = () => {
        close(false)
    }

    const renderByRound = (data, dateField, sortField, renderItem) => {
        if (!data || data.length === 0)
            return <Empty description="ไม่มีข้อมูล" />;

        const grouped = {};
        data.forEach(item => {
            const key = dayjs(item[dateField]).format("YYYY-MM-DD");
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(item);
        });

        const sortedKeys = Object.keys(grouped).sort();

        return (
            <Collapse
                accordion
                items={sortedKeys.map((dateKey, idx) => {
                    const people = [...grouped[dateKey]].sort(
                        (a, b) => a[sortField] - b[sortField]
                    );
                    const confirmedCount = people.filter(p =>
                        p.flagConfirm || p.status3 === "คอนเฟิร์มแล้ว"
                    ).length;
                    return {
                        key: idx,
                        label: (
                            <span style={{ fontWeight: 700, fontSize: 15, display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <span>
                                    รอบที่ {dayjs(dateKey).format("DD/MM/YYYY")}
                                    <span style={{ marginLeft: 8, fontWeight: 400, fontSize: 13, color: "#888" }}>
                                        ({people.length} คน)
                                    </span>
                                </span>
                                <span style={{ marginRight: 24 }}>
                                    <Tag color={confirmedCount === people.length ? "green" : "orange"}>
                                        คอนเฟิร์มแล้ว {confirmedCount}/{people.length}
                                    </Tag>
                                </span>
                            </span>
                        ),
                        children: (
                            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                {people.map((item, i) => renderItem(item, i))}
                            </div>
                        ),
                    };
                })}
            />
        );
    };

    const renderDemandGuaranterByRound = () =>
        renderByRound(workDemandGuaranter, "roundDate", "customerTypeId", renderItemDemandGuarantor);

    const renderCancelContractByRound = () =>
        renderByRound(workCancelContract, "roundDate", "customerTypeId", renderItemWorkCancelContract);

    const renderLetterCarRepurchaseByRound = () =>
        renderByRound(letterCarRepurchase, "createdAt", "customerTypeId", renderItemLetterCarRepurchase);

    const renderLetterAuctionResultByRound = () =>
        renderByRound(letterAuctionResult, "createdAt", "customerTypeId", renderItemLetterAuctionResult);

    const renderItemDemandGuarantor = (item) => {

        const customerType =
            item.customerTypeId === 0
                ? <Tag color="blue">ผู้เช่าซื้อ</Tag>
                : <Tag color="orange">ผู้ค้ำประกัน {item.customerTypeId}</Tag>;

        const status =
            item.statusReply === 1
                ? <Tag color="green">ตอบกลับ</Tag>
                : item.statusReply === 2
                    ? <Tag color="red">ตีกลับ</Tag>
                    : item.statusReply === 3
                        ? <Tag color="purple">ส่งถึงแล้วไม่ตอบกลับ</Tag>
                        : item.statusReply === 4
                            ? <Tag color="default">ไม่มีการเคลื่อนไหว</Tag>
                            : item.statusReply === 5
                                ? <Tag color="cyan">ตอบกลับ(เว็บ)</Tag>
                                : item.statusReply === 6
                                    ? <Tag color="volcano">ตีกลับ(เว็บ)</Tag>
                                    : <Tag>ไม่ระบุ</Tag>;

        const isConfirmed = item.flagConfirm || item.status3 === "คอนเฟิร์มแล้ว";
        return (
            <Card
                size="small"
                style={{
                    borderRadius: 10,
                    border: isConfirmed ? undefined : "1.5px solid #ff4d4f",
                    background: isConfirmed ? "#fafafa" : "#fff1f0"
                }}
            >
                <Row gutter={[16, 10]}>

                    <Col span={24}>
                        <b style={{ fontSize: 15 }}>
                            {item.customerFullName}
                        </b>{" "}
                        {customerType}
                    </Col>

                    <Col span={12}>
                        <b>EMS ไป :</b> {item.parcelNo || "-"}
                    </Col>

                    <Col span={12}>
                        <b>EMS กลับ :</b> {item.parcelNoResponse || "-"}
                    </Col>

                    <Col span={12}>
                        <b>รอบ :</b> <Tag color={"orange"}>{dayjs(item.roundDate).format("DD/MM/YYYY")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สร้างเมื่อ :</b>{" "}
                        <Tag color={"blue"}>{dayjs(item.createdAt).format("DD/MM/YYYY HH:mm")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สถานะ :</b> {status}
                    </Col>

                    <Col span={12}>
                        <b>วันที่จดหมายถึงบริษัท :</b>{" "}
                        {item.dateReply
                            ? <Tag color={"green"}>{dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")}</Tag>
                            : <Tag color={"green"}>-</Tag>}
                    </Col>

                    <Col span={12}>
                        <b>สถานะคอนเฟิร์ม :</b>{" "}
                        {item.flagConfirm
                            ? <Tag color="green">คอนเฟิร์มแล้ว</Tag>
                            : <Tag color="red">ยังไม่คอนเฟิร์ม</Tag>}
                    </Col>

                    <ImageSection images={item.images} />

                </Row>
            </Card>
        );
    };

    const renderItemWorkCancelContract = (item) => {

        const customerType =
            item.customerTypeId === 0
                ? <Tag color="blue">ผู้เช่าซื้อ</Tag>
                : <Tag color="orange">ผู้ค้ำประกัน {item.customerTypeId}</Tag>;

        const status =
            item.statusReply === 1
                ? <Tag color="green">ตอบกลับ</Tag>
                : item.statusReply === 2
                    ? <Tag color="red">ตีกลับ</Tag>
                    : item.statusReply === 3
                        ? <Tag color="purple">ส่งถึงแล้วไม่ตอบกลับ</Tag>
                        : item.statusReply === 4
                            ? <Tag color="default">ไม่มีการเคลื่อนไหว</Tag>
                            : item.statusReply === 5
                                ? <Tag color="cyan">ตอบกลับ(เว็บ)</Tag>
                                : item.statusReply === 6
                                    ? <Tag color="volcano">ตีกลับ(เว็บ)</Tag>
                                    : <Tag>-</Tag>;

        const typeReplyLabel =
            item.typeReply === 5
                ? <Tag color="volcano">บอกเลิก(มือ)</Tag>
                : item.typeReply === 6
                    ? <Tag color="geekblue">สิทธิซื้อรถคืน(เก่า)</Tag>
                    : item.typeReply === 88
                        ? <Tag color="purple">แจ้งผลประมูล</Tag>
                        : null;

        return (
            <Card
                size="small"
                style={{
                    borderRadius: 10,
                    border: item.flagConfirm ? undefined : "1.5px solid #ff4d4f",
                    background: item.flagConfirm ? "#fafafa" : "#fff1f0"
                }}
            >
                <Row gutter={[16, 10]}>

                    <Col span={24}>
                        <b style={{ fontSize: 15 }}>
                            <Tag color={'blue'}>{item.customerFullname}</Tag>
                        </b>{" "}
                        {customerType}
                        {typeReplyLabel && <>{" "}{typeReplyLabel}</>}
                    </Col>

                    <Col span={12}>
                        <b>EMS ไป :</b> {item.parcelNo || "-"}
                    </Col>

                    <Col span={12}>
                        <b>EMS กลับ :</b> {item.parcelNoResponse || "-"}
                    </Col>

                    <Col span={12}>
                        <b>รอบ :</b> <Tag color={"orange"}>{dayjs(item.roundDate).format("DD/MM/YYYY")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สร้างเมื่อ :</b>{" "}
                        <Tag color={"blue"}>{dayjs(item.createdDate).format("DD/MM/YYYY HH:mm")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สถานะ :</b> {status}
                    </Col>

                    <Col span={12}>
                        <b>วันที่จดหมายถึงบริษัท :</b>{" "}
                        {item.dateReply
                            ? <Tag color={"green"}>{dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")}</Tag>
                            : <Tag color={"green"}>-</Tag>}
                    </Col>

                    <Col span={12}>
                        <b>สถานะคอนเฟิร์ม :</b>{" "}
                        {
                            item.flagConfirm ?
                                <Tag color={"green"}>คอนเฟิร์มแล้ว</Tag>
                                :
                                <Tag color={"red"}>ยังไม่คอนเฟิร์มแล้ว</Tag>
                        }
                    </Col>

                    <ImageSection images={item.images} />

                </Row>
            </Card>
        );
    };

    const renderItemLetterCarRepurchase = (item) => {

        const customerType =
            item.customerTypeId === 0
                ? <Tag color="blue">ผู้เช่าซื้อ</Tag>
                : <Tag color="orange">ผู้ค้ำประกัน {item.customerTypeId}</Tag>;

        const status =
            item.statusReply === 1
                ? <Tag color="green">ตอบกลับ</Tag>
                : item.statusReply === 2
                    ? <Tag color="red">ตีกลับ</Tag>
                    : item.statusReply === 3
                        ? <Tag color="purple">ส่งถึงแล้วไม่ตอบกลับ</Tag>
                        : item.statusReply === 4
                            ? <Tag color="default">ไม่มีการเคลื่อนไหว</Tag>
                            : item.statusReply === 5
                                ? <Tag color="cyan">ตอบกลับ(เว็บ)</Tag>
                                : item.statusReply === 6
                                    ? <Tag color="volcano">ตีกลับ(เว็บ)</Tag>
                                    : <Tag>-</Tag>;

        const isConfirmed = item.flagConfirm || item.status3 === "คอนเฟิร์มแล้ว";
        return (
            <Card
                size="small"
                style={{
                    borderRadius: 10,
                    border: isConfirmed ? undefined : "1.5px solid #ff4d4f",
                    background: isConfirmed ? "#fafafa" : "#fff1f0"
                }}
            >
                <Row gutter={[16, 8]}>
                    <Col span={24}>
                        <b style={{ fontSize: 15 }}>
                            {item.customerFullName}
                        </b>{" "}
                        {customerType}
                    </Col>

                    <Col span={12}>
                        <b>EMS ไป :</b> {item.parcelNo || "-"}
                    </Col>

                    <Col span={12}>
                        <b>EMS กลับ :</b> {item.parcelNoResponse || "-"}
                    </Col>

                    <Col span={12}>
                        <b>รอบ :</b> <Tag color={"orange"}>{dayjs(item.roundDate).format("DD/MM/YYYY")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สร้างเมื่อ :</b>{" "}
                        {item.roundDate &&
                            dayjs(item.roundDate).isValid() &&
                            dayjs(item.roundDate).year() > 1900 ? (
                            <Tag color="green">
                                {dayjs(item.roundDate).format("DD/MM/YYYY HH:mm")}
                            </Tag>
                        ) : (
                            <Tag color="green">-</Tag>
                        )}

                    </Col>

                    <Col span={12}>
                        <b>สถานะ :</b> {status}
                    </Col>

                    <Col span={12}>
                        <b>วันที่จดหมายถึงบริษัท :</b>{" "}
                        {item.dateReply &&
                            dayjs(item.dateReply).isValid() &&
                            dayjs(item.dateReply).year() > 1900 ? (
                            <Tag color="green">
                                {dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")}
                            </Tag>
                        ) : (
                            <Tag color="green">-</Tag>
                        )}
                    </Col>

                    <Col span={12}>
                        <b>สถานะคอนเฟิร์ม :</b>{" "}
                        {item.flagConfirm
                            ? <Tag color="green">คอนเฟิร์มแล้ว</Tag>
                            : <Tag color="red">ยังไม่คอนเฟิร์ม</Tag>}
                    </Col>

                    <ImageSection images={item.images} />

                </Row>
            </Card>
        );
    };

    const renderItemLetterAuctionResult = (item) => {

        const customerType =
            item.customerTypeId === 0
                ? <Tag color="blue">ผู้เช่าซื้อ</Tag>
                : <Tag color="orange">ผู้ค้ำประกัน {item.customerTypeId}</Tag>;

        const status =
            item.statusReply === 1
                ? <Tag color="green">ตอบกลับ</Tag>
                : item.statusReply === 2
                    ? <Tag color="red">ตีกลับ</Tag>
                    : item.statusReply === 3
                        ? <Tag color="purple">ส่งถึงแล้วไม่ตอบกลับ</Tag>
                        : item.statusReply === 4
                            ? <Tag color="default">ไม่มีการเคลื่อนไหว</Tag>
                            : item.statusReply === 5
                                ? <Tag color="cyan">ตอบกลับ(เว็บ)</Tag>
                                : item.statusReply === 6
                                    ? <Tag color="volcano">ตีกลับ(เว็บ)</Tag>
                                    : <Tag>-</Tag>;

        const isConfirmed = item.flagConfirm || item.status3 === "คอนเฟิร์มแล้ว";
        return (
            <Card
                size="small"
                style={{
                    borderRadius: 10,
                    border: isConfirmed ? undefined : "1.5px solid #ff4d4f",
                    background: isConfirmed ? "#fafafa" : "#fff1f0"
                }}
            >
                <Row gutter={[16, 8]}>
                    <Col span={24}>
                        <b style={{ fontSize: 15 }}>
                            {item.customerFullName}
                        </b>{" "}
                        {customerType}
                    </Col>

                    <Col span={12}>
                        <b>EMS ไป :</b> {item.parcelNo || "-"}
                    </Col>

                    <Col span={12}>
                        <b>EMS กลับ :</b> {item.parcelNoResponse || "-"}
                    </Col>

                    <Col span={12}>
                        <b>รอบ :</b> <Tag color={"orange"}>{dayjs(item.roundDate).format("DD/MM/YYYY")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สร้างเมื่อ :</b>{" "}
                        {item.roundDate &&
                            dayjs(item.roundDate).isValid() &&
                            dayjs(item.roundDate).year() > 1900 ? (
                            <Tag color="green">
                                {dayjs(item.roundDate).format("DD/MM/YYYY HH:mm")}
                            </Tag>
                        ) : (
                            <Tag color="green">-</Tag>
                        )}

                    </Col>

                    <Col span={12}>
                        <b>สถานะ :</b> {status}
                    </Col>

                    <Col span={12}>
                        <b>วันที่จดหมายถึงบริษัท :</b>{" "}
                        {item.dateReply &&
                            dayjs(item.dateReply).isValid() &&
                            dayjs(item.dateReply).year() > 1900 ? (
                            <Tag color="green">
                                {dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")}
                            </Tag>
                        ) : (
                            <Tag color="green">-</Tag>
                        )}
                    </Col>

                    <Col span={12}>
                        <b>สถานะคอนเฟิร์ม :</b>{" "}
                        {item.flagConfirm
                            ? <Tag color="green">คอนเฟิร์มแล้ว</Tag>
                            : <Tag color="red">ยังไม่คอนเฟิร์ม</Tag>}
                    </Col>

                    <ImageSection images={item.images} />

                </Row>
            </Card>
        );
    };

    return (
        <Modal
            open={open}
            // onCancel={handleClose}
            closable={false}
            footer={null}
            title={data}
            width={800}
        >
            <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
                <Collapse
                    style={{ marginBottom: 16 }}
                    items={[
                        {
                            key: "1",
                            label: (
                                <span style={{ fontWeight: 600, fontSize: 16 }}>
                                    📬 จดหมายบอกกล่าวคนค้ำ ({workDemandGuaranter?.length || 0})
                                </span>
                            ),
                            children: renderDemandGuaranterByRound()
                        }
                    ]}
                />
                <Collapse
                    style={{ marginBottom: 16 }}
                    items={[
                        {
                            key: "2",
                            label: (
                                <span style={{ fontWeight: 600, fontSize: 16 }}>
                                    📑 จดหมายบอกเลิกสัญญา ({workCancelContract?.length || 0})
                                </span>
                            ),
                            children: renderCancelContractByRound()
                        }
                    ]}
                />
                <Collapse
                    style={{ marginBottom: 16 }}
                    items={[
                        {
                            key: "3",
                            label: (
                                <span style={{ fontWeight: 600, fontSize: 16 }}>
                                    📄 จดหมายซื้อรถคืน ({letterCarRepurchase?.length || 0})
                                </span>
                            ),
                            children: renderLetterCarRepurchaseByRound()
                        }
                    ]}
                />
                <Collapse
                    style={{ marginBottom: 16 }}
                    items={[
                        {
                            key: "3",
                            label: (
                                <span style={{ fontWeight: 600, fontSize: 16 }}>
                                    📄 จดหมายแจ้งผลประมูล ({letterAuctionResult?.length || 0})
                                </span>
                            ),
                            children: renderLetterAuctionResultByRound()
                        }
                    ]}
                />
                <Divider />
            </Spin>
            <Col span={24} style={{ textAlign: "end" }}>
                <Button
                    type='primary'
                    danger
                    onClick={handleClose}>
                    ปิด
                </Button>
            </Col>
        </Modal>
    )
}

export default CheckCONTNO